<top-banner variant="custom">
    <h2 class="title mb-3">Training Course</h2>
    <button type="button" [disabled]="!contractors?.length" (click)="export()" class="btn btn-success btn-round"><i class="fas fa-download"></i>
      &nbsp;
      <strong>EXPORT CSV</strong>
    </button>
</top-banner>

<div class="main-content">
  <div class="row">
    <div class="col-md-12">
      <div class="card">
        <div *ngIf="contractors" class="row animated fadeIn">
          <!-- side menu -->
          <div class="col-md-2 cardtabs-wrapper">
            <nav class="nav cardtabs flex-column">
              <div class="back-and-menu-link">
                <a [routerLink]="['/', routeRole, 'training', trainingId]" class="nav-link back-link">course details</a>
              </div>
            </nav>
          </div>

          <!-- main area -->
          <div class="col-md-10">
            <div class="card-body mb-2">
              <h4 class="card-title">{{contractors[0]?.course.trainingName}}</h4>
              <a class="btn btn-success btn-round float-right" (click)="openAssignAcceptanceModal()">assign to contractors</a>

              <div class="row">
                <div class="col-md-12">
                  <p-table
                  [autoLayout]="true"
                  [value]="contractors"
                  selectionMode="single"
                  [lazy]="true"
                  >
                    <ng-template pTemplate="header">
                      <tr>
                        <th>Company Name</th>
                        <th>Status</th>
                        <th></th>
                      </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-company>
                      <tr [pSelectableRow]="company">
                        <td>{{ company.contractorName }}</td>
                        <td>
                          <span *ngIf="company.courseProgress === TrainingCourseStateType.Completed" class="badge badge-pill badge-success">Completed - Accepted On: {{company.lastModifiedDate | date: 'yyyy-MM-dd'}}</span>
                          <span *ngIf="company.courseProgress === TrainingCourseStateType.Expired" class="badge badge-pill badge-success">Completed - Inactive</span>
                          <span *ngIf="company.courseProgress === TrainingCourseStateType.NotStarted" class="badge badge-pill badge-warning">Pending</span>
                          <span *ngIf="company.courseProgress === TrainingCourseStateType.InProgress" class="badge badge-pill badge-warning">Pending</span>
                        </td>
                        <td>
                          <button type="button" (click)="goToContractor(company.contractorId)" class="btn btn-primary btn-link">view</button>
                        </td>
                      </tr>
                    </ng-template>
                    <ng-template pTemplate="emptymessage" let-columns>
                      <tr>
                        <td [attr.colspan]="3">No contractors found</td>
                      </tr>
                    </ng-template>
                  </p-table>
                </div>
              </div>

            </div>
          </div>
        </div>
        <div class="card-footer">
          <p-paginator #paginator [rows]="pagination.size" [totalRecords]="pagination.totalRecords" [rowsPerPageOptions]="pageSizes" (onPageChange)="paginate($event)"></p-paginator>
        </div>
      </div>
    </div>
  </div>
</div>

<p-dialog header="Assign Outage Acceptance" [(visible)]="showAssignAcceptanceModal" modal="true" [baseZIndex]="1000000">
  <form *ngIf="!saveInProgress" [formGroup]="assignAcceptanceForm" (ngSubmit)="onAssignAcceptanceFormSubmit()">
    <div class="row">
      <div class="col-md-12" *ngIf="allContractors.length">
        <div class="form-group">
          <label>Select Contractor</label>
          <p-multiSelect
            class="form-control"
            formControlName="contractor"
            [options]="allContractors"
            optionLabel="label"
            defaultLabel="Select Contractor"
            [style]="{ width: '100%' }"
            filter="true">
          </p-multiSelect>
        </div>
      </div>
      <div class="col-md-12" *ngIf="!allContractors.length">
        <label>Select Contractor</label>
        <p-dropdown class="form-control" placeholder="No contractors found. Try again later or contact support"></p-dropdown>
        <br>
      </div>
    </div>
  </form>
  <div *ngIf="saveInProgress" style="width: 50%; margin: 0 auto">
    <p-progressSpinner></p-progressSpinner>
  </div>
  <p-footer>
    <button type="button" (click)="showAssignAcceptanceModal = false" [disabled]="saveInProgress" class="my-2 btn btn-round btn-sm btn-default float-left">Cancel</button>
    <button type="button" (click)="onAssignAcceptanceFormSubmit()" [disabled]="!assignAcceptanceForm.valid || saveInProgress" class="my-2 btn btn-round btn-sm btn-success">Assign</button>
  </p-footer>
</p-dialog>
